import { styled } from "@mui/material";
import {
  Box as MuiBox,
  Button as MuiButton,
  Alert as MuiAlert
} from "@mui/material"


export const TokenContainer = styled(MuiBox)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const LoadingContainer = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const ErrorContainer = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const TokenBox = styled(MuiBox)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: 'rgba(25, 118, 210, 0.05)',
  borderRadius: theme.shape.borderRadius * 2,
  border: '1px dashed',
  borderColor: theme.palette.primary.light,
  width: '100%',
  position: 'relative',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  }
}));

export const TokenText = styled(MuiButton)(({ theme }) => ({
  fontSize: 18,
  fontFamily: 'monospace',
  fontWeight: 600,
  letterSpacing: 1,
  color: theme.palette.text.primary,
  wordBreak: 'break-all'
}));

export const CloseButton = styled(MuiButton)(({ theme }) => ({
  padding: theme.spacing(1.5),
  fontWeight: 500
}));

export const StyledAlert = styled(MuiAlert)(({ theme }) => ({
  width: '100%',
  boxShadow: theme.shadows[3],
  alignItems: 'center'
}));
